
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 340.16 340.16"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{staticClass:"p123-quaternary",attrs:{"x":"14.17","y":"14.17","width":"311.81","height":"311.81","rx":"28.35"}}),_c('path',{staticClass:"p123-primary",attrs:{"d":"M297.64 14.17A28.38 28.38 0 01326 42.52v255.12A28.37 28.37 0 01297.64 326H42.52a28.38 28.38 0 01-28.35-28.34V42.52a28.38 28.38 0 0128.35-28.35h255.12m0-14.17H42.52A42.64 42.64 0 000 42.52v255.12a42.65 42.65 0 0042.52 42.52h255.12a42.65 42.65 0 0042.52-42.52V42.52A42.65 42.65 0 00297.64 0z"}}),_c('path',{staticClass:"p123-tertiary",attrs:{"d":"M76.71 169c2.92-3.4 4.82-6.53 4.82-9.49 0-5.56-5-9.2-5-20.43 0-25.82 41.88-46.76 93.53-46.76s93.52 20.94 93.52 46.76c0 10.32-7.17 14.57-7.17 20.43 0 3 2.44 6.35 6.09 10.08 12.43-9.53 19.71-21.08 19.71-33.53 0-32.71-50.25-59.23-112.23-59.23S57.77 103.34 57.77 136.05c0 12.19 6.98 23.52 18.94 32.95z"}}),_c('path',{staticClass:"p123-tertiary",attrs:{"d":"M170.08 60.8a15.59 15.59 0 11-15.59-15.59 15.59 15.59 0 0115.59 15.59z"}}),_c('path',{staticClass:"p123-tertiary",attrs:{"d":"M201.25 60.8a15.59 15.59 0 11-15.58-15.59 15.58 15.58 0 0115.58 15.59z"}}),_c('path',{staticClass:"p123-secondary",attrs:{"d":"M256.43 159.5c0-5.86 7.17-10.11 7.17-20.43 0-25.82-41.87-46.76-93.52-46.76s-93.53 20.94-93.53 46.76c0 11.23 5 14.87 5 20.43 0 12.95-36.15 29-36.15 57.51 0 43.05 55.83 77.94 124.7 77.94s124.7-34.89 124.7-77.94c-.02-29.09-38.37-45.47-38.37-57.51z"}})])
          )
        }
      }
    